import type { ReactNode } from 'react';
import { cn } from './lib/cn';

export function SectionHeader({
  eyebrow,
  title,
  description,
  actions,
  className,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'grid grid-cols-[minmax(0,1fr)_auto] items-start gap-4 sm:flex sm:items-center sm:justify-between',
        className
      )}
    >
      <div className='min-w-0'>
        {eyebrow && (
          <div className='text-[11px] font-semibold uppercase tracking-wider text-brand-orange'>
            {eyebrow}
          </div>
        )}
        <h2 className='truncate font-display text-xl font-bold text-brand-navy sm:text-2xl'>
          {title}
        </h2>
        {description && (
          <p className='mt-1 text-sm text-muted-foreground'>{description}</p>
        )}
      </div>
      {actions && <div className='flex shrink-0 items-center gap-2'>{actions}</div>}
    </div>
  );
}
